import { useQuery } from '@tanstack/react-query';
import { getUserState } from '@carvana/core-auth';

import Api from 'api/Api';
import type { VehicleSummariesData } from 'api/GraphQL/queries/getVehicleSummaries';

export const APPRAISAL_SUMMARY_BFF_QUERY = 'APPRAISAL_SUMMARY_BFF_QUERY';

export const getSummariesQueryKey = (isLoggedIn: boolean): [string, boolean] => [
  APPRAISAL_SUMMARY_BFF_QUERY,
  isLoggedIn
];

const useGetSummaries = () => {
  const { isLoggedIn } = getUserState();

  // Plain (non-suspense) query: a failure resolves to data: undefined
  // instead of throwing into the landing-page error boundary. Hero already
  // treats a missing/empty summaries payload as "show the entry form", so
  // this degrades to that existing, already-shipped state rather than a
  // permanent loading skeleton. No retry — landing on the entry form is an
  // acceptable fallback on its own, not something worth masking with delay.
  return useQuery<VehicleSummariesData>({
    queryKey: getSummariesQueryKey(isLoggedIn),
    queryFn: () =>
      isLoggedIn ? Api.appraisalBff.getSummaries() : Promise.resolve({ vehicleSummaries: [] }),
    gcTime: 1000 * 60 * 60, // one hour
    staleTime: 1000 * 60 * 30, // 30 minutes
    refetchOnWindowFocus: false,
    retry: false
  });
};

export default useGetSummaries;
